import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getSearchCategoryOptions } from '../../constants/sideMenuCategories';

const Select = styled.select`
  flex-shrink: 0;
  max-width: ${(props) => props.$maxWidth || '148px'};
  border: none;
  border-right: 1px solid #e0e0e0;
  background: #f3f3f3;
  color: #232f3e;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.65rem 0.45rem 0.65rem 0.55rem;
  outline: none;
  cursor: pointer;
  appearance: auto;

  &:focus {
    background: #eaeaea;
  }

  @media (max-width: 768px) {
    max-width: ${(props) => props.$mobileMaxWidth || '112px'};
    font-size: 0.72rem;
    padding: 0.55rem 0.3rem 0.55rem 0.4rem;
  }
`;

/**
 * Category filter for search bars — same departments as Men/Women/Kids/Babies browse.
 */
const SearchCategorySelect = ({
  value = '',
  onChange,
  className,
  maxWidth,
  mobileMaxWidth,
  styleVariant = 'default',
  accentColor,
}) => {
  const { t } = useTranslation();
  const options = getSearchCategoryOptions();
  const lightText = accentColor || '#1b4332';

  return (
    <Select
      className={className}
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      aria-label={t('search.allCategories')}
      $maxWidth={maxWidth}
      $mobileMaxWidth={mobileMaxWidth}
      style={
        styleVariant === 'pill' ||
        styleVariant === 'frameless' ||
        styleVariant === 'framelessLight'
          ? {
              background: 'transparent',
              borderRight:
                styleVariant === 'frameless'
                  ? '1px solid rgba(255, 255, 255, 0.25)'
                  : `1px solid ${accentColor ? `${accentColor}33` : 'rgba(27, 67, 50, 0.2)'}`,
              color: styleVariant === 'frameless' ? '#fff' : lightText,
              fontWeight: 600,
              paddingLeft: 0,
            }
          : undefined
      }
    >
      <option value="">{t('search.allCategories')}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </Select>
  );
};

export default SearchCategorySelect;
